<script>
  export let className;
</script>

<style>
  .empty-sad {
    height: 4.5rem;
    width: 4.5rem;
  }
</style>

<svg class={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48"><title>cry 15</title><g class="nc-icon-wrapper"><path d="M24,46A22,22,0,1,1,46,24,22.025,22.025,0,0,1,24,46Z" fill="#ffd764"/> <path d="M15,25a3,3,0,1,1,3-3A3,3,0,0,1,15,25Z" fill="#444"/> <path d="M33,25a3,3,0,1,1,3-3A3,3,0,0,1,33,25Z" fill="#444"/> <path d="M34,35a3,3,0,0,1-3-3c0-1.278,1.522-3.621,2.177-4.568a1.038,1.038,0,0,1,1.646,0C35.478,28.379,37,30.722,37,32A3,3,0,0,1,34,35Z" fill="#00b4dc"/> <path d="M30.942,39.034a1,1,0,0,1-.868-.5,6.99,6.99,0,0,0-12.148,0,1,1,0,0,1-1.735-.994,8.989,8.989,0,0,1,15.618,0,1,1,0,0,1-.867,1.5Z" fill="#444"/></g></svg>